// Core
export { createConnector } from 'react-instantsearch-core';
export { HIGHLIGHT_TAGS } from 'react-instantsearch-core';
export { translatable } from 'react-instantsearch-core'; // Widget

export { Configure } from 'react-instantsearch-core';
export { ExperimentalConfigureRelatedItems } from 'react-instantsearch-core';
export { QueryRuleContext } from 'react-instantsearch-core';
export { Index } from 'react-instantsearch-core';
export { InstantSearch } from 'react-instantsearch-core'; // Connectors

export { connectAutoComplete } from 'react-instantsearch-core';
export { connectBreadcrumb } from 'react-instantsearch-core';
export { connectConfigure } from 'react-instantsearch-core';
export { EXPERIMENTAL_connectConfigureRelatedItems } from 'react-instantsearch-core';
export { connectCurrentRefinements } from 'react-instantsearch-core';
export { connectDynamicWidgets, EXPERIMENTAL_connectDynamicWidgets } from 'react-instantsearch-core';
export { connectGeoSearch } from 'react-instantsearch-core';
export { connectHierarchicalMenu } from 'react-instantsearch-core';
export { connectHighlight } from 'react-instantsearch-core';
export { connectHitInsights } from 'react-instantsearch-core';
export { connectHits } from 'react-instantsearch-core';
export { connectHitsPerPage } from 'react-instantsearch-core';
export { connectInfiniteHits } from 'react-instantsearch-core';
export { connectMenu } from 'react-instantsearch-core';
export { connectNumericMenu } from 'react-instantsearch-core';
export { connectPagination } from 'react-instantsearch-core';
export { connectPoweredBy } from 'react-instantsearch-core';
export { connectQueryRules } from 'react-instantsearch-core';
export { connectRange } from 'react-instantsearch-core';
export { connectRefinementList } from 'react-instantsearch-core';
export { connectScrollTo } from 'react-instantsearch-core';
export { connectSearchBox } from 'react-instantsearch-core';
export { connectRelevantSort } from 'react-instantsearch-core';
export { connectSortBy } from 'react-instantsearch-core';
export { connectStateResults } from 'react-instantsearch-core';
export { connectStats } from 'react-instantsearch-core';
export { connectToggleRefinement } from 'react-instantsearch-core'; // DOM

export { default as Breadcrumb } from "./widgets/Breadcrumb.js";
export { default as ClearRefinements } from "./widgets/ClearRefinements.js";
export { default as CurrentRefinements } from "./widgets/CurrentRefinements.js";
export { default as HierarchicalMenu } from "./widgets/HierarchicalMenu.js";
export { default as Highlight } from "./widgets/Highlight.js";
export { default as Hits } from "./widgets/Hits.js";
export { default as HitsPerPage } from "./widgets/HitsPerPage.js";
export { default as InfiniteHits } from "./widgets/InfiniteHits.js";
export { default as Menu } from "./widgets/Menu.js";
export { default as MenuSelect } from "./widgets/MenuSelect.js";
export { default as NumericMenu } from "./widgets/NumericMenu.js";
export { default as Pagination } from "./widgets/Pagination.js";
export { default as Panel } from "./widgets/Panel.js";
export { default as PoweredBy } from "./widgets/PoweredBy.js";
export { default as RangeInput } from "./widgets/RangeInput.js";
export { default as RangeSlider } from "./widgets/RangeSlider.js";
export { default as RatingMenu } from "./widgets/RatingMenu.js";
export { default as RefinementList } from "./widgets/RefinementList.js";
export { default as ScrollTo } from "./widgets/ScrollTo.js";
export { default as SearchBox } from "./widgets/SearchBox.js";
export { default as Snippet } from "./widgets/Snippet.js";
export { default as RelevantSort } from "./widgets/RelevantSort.js";
export { default as SortBy } from "./widgets/SortBy.js";
export { default as Stats } from "./widgets/Stats.js";
export { default as ToggleRefinement } from "./widgets/ToggleRefinement.js";
export { default as VoiceSearch } from "./widgets/VoiceSearch.js";
export { default as QueryRuleCustomData } from "./widgets/QueryRuleCustomData.js";
export { default as EXPERIMENTAL_Answers } from "./widgets/Answers.js";
import DynamicWidgets from "./widgets/DynamicWidgets.js";
/** @deprecated use DynamicWidgets */

var ExperimentalDynamicWidgets = DynamicWidgets;
export { DynamicWidgets, ExperimentalDynamicWidgets }; // hooks

export { default as EXPERIMENTAL_useAnswers } from "./hooks/useAnswers.js"; // Utils

export { createClassNames } from "./core/utils.js"; // voiceSearchHelper

export { default as createVoiceSearchHelper } from "./lib/voiceSearchHelper/index.js"; // insights

export { default as getInsightsAnonymousUserToken } from "./core/getInsightsAnonymousUserToken.js"; // InfiniteHits Cache

export { createInfiniteHitsSessionStorageCache } from "./lib/infiniteHitsCache/index.js";